<template>
  <node-view-wrapper>
    <details :class="node.attrs.class" ref="refDetails" open :id="node.attrs.id">
      <div class="havet-details-actions">
        <v-btn @click="updateTitle" icon small>
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
        <v-btn @click="deleteSummary" icon small>
          <v-icon small>mdi-delete</v-icon>
        </v-btn>
        <v-menu>
          <template v-slot:activator="{ on, attrs }">
            <v-btn small icon v-bind="attrs" v-on="on">
              <v-icon>mdi-dots-horizontal</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              link
              v-for="(item, i) in colorOptions"
              :key="i"
              @click="addClass(item.value)"
            >
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <summary class="havet-details-label" contenteditable="false">
        {{ node.attrs.title }}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="1em"
          height="1em"
          viewBox="0 0 24 24"
          class="chevron"
        >
          <path
            fill="currentColor"
            d="M22 12a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10M7.4 15.4l4.6-4.6l4.6 4.6L18 14l-6-6l-6 6z"
          />
        </svg>
      </summary>
      <node-view-content class="havet-details-content" />
    </details>
    <Confirm ref="confirm" />
  </node-view-wrapper>
</template>

<script>
import { NodeViewContent, nodeViewProps, NodeViewWrapper } from '@tiptap/vue-2'
import Confirm from '@/components/shared/Confirm'

export default {
  components: {
    NodeViewWrapper,
    NodeViewContent,
    Confirm,
  },
  data() {
    return {
      colorOptions: [
        { name: 'Grå', value: 'havet-details-bg-grey' },
        { name: 'Blå', value: 'havet-details-bg-blue' },
        { name: 'Grön', value: 'havet-details-bg-green' },
      ],
    }
  },
  props: nodeViewProps,
  mounted() {
    this.$refs.refDetails.addEventListener('toggle', this.onToggle)
    this.editor.commands.selectTextblockEnd()
  },
  beforeDestroy() {
    this.$refs.refDetails.removeEventListener('toggle', this.onToggle)
  },
  methods: {
    addClass(cssClass) {
      const classList = [...this.node.attrs.class].filter((c) => !c.includes('havet-details-bg-'))
      this.updateAttributes({
        class: [...classList, cssClass],
      })
    },
    onToggle({ newState }) {
      this.updateAttributes({
        isOpen: newState === 'open',
      })
    },
    updateTitle() {
      // eslint-disable-next-line no-alert
      const newTitle = prompt('Ange ny titel', this.node.attrs.title)
      this.updateAttributes({
        title: newTitle ? newTitle : this.node.attrs.title,
        isOpen: this.node.attrs.isOpen,
        id: newTitle ? newTitle.toLowerCase().replace(/ /g, '-') : this.node.attrs.id,
      })
    },
    async deleteSummary() {
      const shouldDelete = await this.$refs.confirm.open({
        title: 'Radera',
        message: 'Är du säker på att du vill radera rutan',
        saveButtonText: 'Ja',
        cancelButtonText: 'Avbryt',
      })
      if (shouldDelete) this.deleteNode()
    },
  },
}
</script>

<style lang="less">
.havet-details {
  position: relative;
  padding: 20px 30px;
  margin: 1rem 0;
  background-color: rgb(236, 236, 236);
  position: relative;
  &.havet-details-bg-grey {
    background-color: rgb(236, 236, 236);
  }
  &.havet-details-bg-blue {
    background-color: rgb(234, 246, 244);
  }
  &.havet-details-bg-green {
    background-color: rgb(248, 248, 231);
  }
  .havet-details-actions {
    padding: 3px;
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    flex-direction: row;
    button {
      margin-left: 0.3rem;
    }
  }
  .havet-details-label {
    user-select: none;
    font-size: 18px;
    font-weight: 700;
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .havet-details-content {
    // margin: 2.5rem 1rem 1rem;
    padding-top: 0.5rem;
    // border: 2px dashed #0d0d0d20;
    // border-radius: 0.5rem;
  }
}

.havet-details[open] .chevron {
  transform: rotate(0deg);
}
.havet-details .chevron {
  transition: transform 0.1s ease-in-out;
  transform-origin: center;
  transform: rotate(180deg);
}
details > summary {
  list-style: none;
}
details > summary::-webkit-details-marker {
  display: none;
}
</style>
